import { Flex } from "antd";
import { FC, ReactNode } from "react";

import { SecondaryText } from "@/shared/ui/Typography";

export const MetaRow: FC<{
    icon: ReactNode;
    label: string;
    children: ReactNode;
}> = ({ icon, label, children }) => (
    <Flex gap={10} align="center">
        <Flex
            justify="center"
            align="center"
            style={{
                width: 18,
            }}
        >
            {icon}
        </Flex>

        <SecondaryText style={{ width: 100 }}>{label}</SecondaryText>

        <Flex flex={1} style={{ minWidth: 0 }}>
            {children}
        </Flex>
    </Flex>
);
